<template>
  <div>
    <AuthHeader :title=" $t('auth.recover.title')" />

    <Form @submit="submit">
      <Alert v-if="submitFailed" type="danger" :message="$t('auth.recover.recoverPasswordFailedErrorMessage')" />

      <Paragraph v-if="submitSucceeded" :text="$t('auth.recover.success')" />

      <div v-else>
        <Paragraph :text="$t('auth.recover.helpText')" />

        <FormField :label="$t('general.email')">
          <EmailInputField v-model="email" :valid="isValid" :disabled="isSubmitting" />
          <HelpText v-if="!isValid" type="danger" :text="$t('auth.recover.invalidEmail')" />
        </FormField>

        <Button
          type="secondary"
          :title="$t('general.recover')"
          :loading="isSubmitting"
          fullwidth
          @click="submit">
        </Button>
      </div>
    </Form>

    <AuthFooter />
  </div>
</template>

<script>
import * as utils from '@/assets/libs/utils/'

import AuthHeader from '@/modules/auth/components/AuthHeader.vue'
import AuthFooter from '@/modules/auth/components/AuthFooter.vue'

const STATUS_DEFAULT = ''
const STATUS_SUBMITTING = 'submitting'
const STATUS_ERROR = 'error'
const STATUS_SUCCESS = 'success'

export default {
  components: {
    AuthHeader,
    AuthFooter
  },

  data () {
    return {
      email: '',
      isValid: true,
      status: STATUS_DEFAULT
    }
  },

  computed: {
    isSubmitting () {
      return this.status === STATUS_SUBMITTING
    },

    submitSucceeded () {
      return this.status === STATUS_SUCCESS
    },

    submitFailed () {
      return this.status === STATUS_ERROR
    }
  },

  watch: {
    email () {
      this.isValid = true
    }
  },

  methods: {
    async submit () {
      this.status = STATUS_DEFAULT

      if (this.validate()) {
        this.status = STATUS_SUBMITTING

        try {
          await this.$store.dispatch('auth/recoverPassword', this.email)
          this.status = STATUS_SUCCESS
        } catch (error) {
          this.status = STATUS_ERROR
          console.error(error)
        }
      }
    },

    validate () {
      this.isValid = utils.validateEmail(this.email)
      return this.isValid
    }
  }
}
</script>
